import {
  formatStyle,
  removeMedia,
} from "@/components/mobile/generation/Image/Tabs/initStyle.js";
import {
  MateSearchSorterEnum,
  SorterEnum,
  TraitAnimationPortraitType,
  TraitAnimationType,
} from "@/enums";
import { InputTypeEnum, MateCardFactoryGenerateType } from "@/enums/chatEnums";
import { MateSearchableFields, MateType } from "@/enums/mateEnums";
import { TranslationLanguageEnum } from "@/enums/translateEnums";
import i18n from "@/locales";
import { StorageSet } from "@/tools/localStorage";
import { sessionStorageSet } from "@/tools/sessionStorage";
import {
  CreateOneUserReq,
  CursorPageRequest,
  CursorPageResponse,
  ItemResponse,
  PageRequest,
  PageResponse,
  ReadNotificationPageRequest,
  Response,
  Role,
  WriteResponse,
} from "@/types/api-types";
import {
  Admirer,
  AdmirerCommit,
  AndroidVersion,
  AvatarDraw,
  ChatMate,
  ChatMessage,
  ChatSample,
  DispatchTemplate,
  Emoji,
  EmojiVote,
  Follower,
  HouseEvent,
  HouseMap,
  ImagePrompt,
  InpaintType,
  Mate,
  MateCommit,
  MateCommitStatus,
  MateDispatchMessage,
  MateEquipment,
  MateHouseSession,
  MateHouseSessionEvent,
  MateHouseSessionMessage,
  MateLink,
  MateMedia,
  MateModule,
  MateSession,
  MateStatus,
  MateTone,
  MateToneCategory,
  MateToneConfig,
  MateTraitAnimation,
  MateTraitMedia,
  Media,
  MediaResourceType,
  MediaType,
  Module,
  ModuleEntityType,
  ModuleMedia,
  ModuleQuestion,
  Moment,
  Notification,
  Reply,
  SessionMode,
  Story,
  StoryBook,
  StoryChapter,
  TaskEntityType,
  TaskStatus,
  TextAudio,
  User,
  UserShareReward,
  Visibility,
} from "@/types/entity";
import { NotifyData } from "@/types/notification";
import axios, { AxiosError } from "axios";
import { deleteOne, fetchStream, get, post, put } from "./request.js";
import { EquipmentRarity } from "@/enums/mission.js";
import { HouseEventLocation } from "@/enums/houseEventEnums.js";
import { ChestType } from "@/types/user.js";

export default {
  createOneAudioText,
  readAllChatSessionPage,

  updateManyChatMessage,
  createOneChatMessage,
  readChatMessagePage,
  updateChatMessage,
  deleteOneChatMessage,
  updateOneChatMessageAudio,
  updateOneChatMessageScene,
  updateOneChatMessageFace,
  createChatMessageQuestion,
  createChatMessageSummary,

  readMateSessionPage,
  readMateSessionByMateId,
  createOneMateSession,
  createOneMateMessage,
  readMateMessagePage,
  readOneMateSession,
  deleteOneMateSession,
  updateOneMateSession,
  updateChatStatus,
  updateMateSessionMode,

  signOut,
  deleteImpersonate,

  createOneChatSession,
  readOneChatSessionBy,
  deleteOneChatSession,
  readChatSessionPage,
  readChatMessageCount,

  readOneSavePoint,
  readSavePointTree,
  readChatMessageSavepointTreePage,
  generateSavePointDescription,

  createOneHint,
  getLanguage,
  readSceneHome,
  changeLanguage,
  updateUser,
  bindEmail,
  bindPhone,
  UserInvitationCodeCheck,
  getAllSubscription,
  createOneGuest,
  createOneUser,
  readUser,
  claimChest,
  readSiteMessage,
  readUserHome,
  deleteUserHome,
  changeUserHome,
  createOneVerification,

  readMateAvatar,
  deleteOneMateAvatar,
  createOneMateAvatar,
  readMateTone,
  readMateToneCategoryPage,
  readBgmTone,
  createOneMate,
  readMateAdmiringPage,
  deleteOneMate,
  playTextAudio,
  publishOneMate,
  updateMate,
  updateMateDetail,
  generateMateDescription,
  createOneMateStyle,
  deleteOneMateStyle,
  readMateStylePage,

  updateSavePoint,
  createOnePublishPoint,
  deleteSavePoint,

  readOneMate,
  readMatePersonalityPrompt,
  readMatePage,
  readAiMatePage,
  readMateLinkPage,
  createOneMateLink,
  updateOneMateLink,
  deleteOneMateLink,
  importManyMateLink,

  readMediaPage,
  readMateMediaPage,
  deleteMateMedia,
  updateMateMedia,

  createOneMateMedia,
  updateOneMateMedia,
  createOrUpdateManyMateMedia,
  readModuleMediaPage,
  createOneModuleMedia,
  deleteOneModuleMedia,
  uploadMedia,
  uploadNsfwMedia,
  readPresetMatePromptPage,
  updateHint,
  forkSavepoint,
  deleteMsg,
  readSavePointPage,

  readReplyPage,
  readReplyTreePage,
  createOneReply,
  updateOneReply,
  deleteReply,
  createOnePageView,

  readEmojiPage,
  createEmojiVote,

  readCommentPage,

  readNotificationPage,
  readNotificationSummary,
  changeNotificationRead,
  changeNotificationReadAll,

  readMomentExplorePage,
  readMomentFollowingPage,
  readMomentFriendsPage,
  readTreeholeMomentPage,
  readMomentPage,
  createMoment,
  updateMoment,
  postMomentComplete,
  readOneMoment,
  deleteOneMoment,

  createOneFollower,
  readFollowerPage,
  deleteOneFollower,

  createOneAdmirer,
  createOneAdmirerRequest,
  readAdmirerPage,
  readAdmireSubscriptionPage,
  deleteOneAdmirer,
  readAdmirerRequestPage,
  reviewAdmirer,

  readMateCommitPage,
  createOneMateCommit,
  reviewMateCommit,

  readModulePage,
  createOneModule,
  deleteOneModule,
  updateOneModule,

  readModuleQuestionPage,
  createOneModuleQuestion,
  deleteOneModuleQuestion,
  updateOneModuleQuestion,

  readMateModulePage,
  createOneMateModule,
  deleteOneMateModule,
  updateOneMateModule,

  readTaskPage,
  updateOneTask,
  deleteOneTask,
  createOneMediaExtend,
  retryTask,
  readTextImagePage,
  readTextImageByUuid,
  readUnmarkedTaskCount,
  updateOneTextImage,
  createOneTextImage,
  createOneTextImageTrait,
  createOneTextImageTask,
  readImagePromptPage,
  createOneTextGifTask,

  createOneMateTrait,
  updateOneMateTrait,
  readMateTraitPage,
  deleteOneMateTrait,

  readMateTraitPortraitPage,
  createOneMateTraitPortrait,
  deleteOneMateTraitPortrait,
  updateOneMateTraitPortrait,

  createOneStory,
  updateOneStory,
  deleteOneStory,
  readStoryPage,
  putStorySort,
  readOneStory,
  createOneStoryVideo,

  createOneStoryBook,
  readOneStoryBook,
  readStoryBookPoplarPage,
  readStoryBookPage,
  updateOneStoryBook,
  deleteOneStoryBook,
  storyBookImportStory,

  readStoryChapterPage,
  createOneStoryChapter,
  deleteOneStoryChapter,
  updateOneStoryChapter,

  storyGenerate,
  storyWriteGenerate,
  storyImageGeneration,
  storyPromptExtract,
  storyDuplicate,
  storyWrite,

  readMatePopular,
  readMatePopularPage,
  readMateListByUserMateId,
  readMateSearchPage,
  readMomentSearchPage,
  storyScreenshot,

  inpaintImage,
  mediaReplace,
  updateTextImage,
  deleteOneTextImage,

  createOneChatSample,
  readChatSamplePage,
  deleteOneChatSample,
  updateOneChatSample,

  readMateTraitMediaPage,
  readPopular,
  readRecommended,

  createOneMateTraitAnimation,
  updateOneMateTraitAnimation,
  deleteOneMateTraitAnimation,
  readMateTraitAnimationPage,
  readOneMateTraitAnimation,
  payOneChatMessage,

  translate,

  createUserInvitationCode,
  readUserInvitationCodePage,
  checkUserExist,
  createOneUserShareReward,

  updateOneMateHouseSession,
  readMateHouseSessionMessagePage,
  deleteMateHouseSessionMessage,
  getOneMateHouseSession,
  cloneOneMate,
  readPresetMatePage,
  createOneMateHouseSessionEvent,
  readOneMateHouseSessionEvent,
  updateOneMateHouseSessionEvent,
  readHouseEventPage,

  readHouseMapPage,
  createHouseMap,
  readOneHouseMap,
  updateHouseMap,
  deleteHouseMap,
  createOneAndroidVersion,

  readMateDispatchMessagePage,
  createOneMateDispatchMessage,
  readDispatchTemplatePage,
  readOneDispatchTemplate,
};

function readPopular() {
  return get("/Popular");
}

function readRecommended(params: CursorPageRequest<null>) {
  return get("/Recommended", params);
}

/**
 *
 * @param {number} uploadId
 * @returns {Promise<AM.ApiItemResponse<AM.AudioText>>}
 */
function createOneAudioText(uploadId) {
  return post("/AudioText/0", { uploadId });
}

/**
 *
 * @param {number} chatMessageId
 * @param {string} text
 * @returns {Promise<AM.ApiItemResponse<AM.Hint>>}
 */
function createOneHint(chatMessageId, text = "") {
  chatMessageId = parseInt(chatMessageId);
  return post("/Hint/0", { chatMessageId, text });
}

/**
 *
 * @returns {Promise<AM.ApiDataResponse<AM.SceneHome>>}
 */
function readSceneHome() {
  return get("/SceneHome");
}

/**
 *
 * @param {string} name
 * @returns {Promise<AM.ApiItemResponse<AM.User>>}
 */
function createOneGuest(name) {
  return post("/Guest/0", { name });
}

function createOneUser(params: CreateOneUserReq): Promise<WriteResponse<User>> {
  return post("/User/0", params);
}

function readUser(id) {
  return get(`/User/${id}`);
}

// User/ClaimChest
function claimChest(
  type: ChestType,
  rarity?: EquipmentRarity
): Promise<ItemResponse<MateEquipment>> {
  return post("/User/ClaimChest", { rarity, type });
}

/**
 *
 * @returns {Promise<AM.ApiDataResponse<AM.User>>}
 */
async function readUserHome(): Promise<Response<User>> {
  const resp = await get("/UserHome");
  localStorage.setItem("user", JSON.stringify(resp.data));
  sessionStorageSet("user", resp.data);
  return resp;
}

function readSiteMessage(
  uuid: string
): Promise<WriteResponse<{ title: string; content: string }>> {
  return get(`/SiteMessage/${uuid}`);
}

async function deleteUserHome(): Promise<Response<User>> {
  return await deleteOne("/UserHome");
}

function changeUserHome(params) {
  return put("/UserHome", params);
}

/**
 *
 * @param {string} phoneCountry
 * @param {string} phone
 * @returns {Promise<AM.ApiItemResponse<AM.Verification>>}
 */
function createOneVerification(params: {
  email?: string;
  phone?: string;
  type?: number;
}) {
  return post("/Verification/0", params);
}

function readMateAvatar(page, filter) {
  return get("/MateAvatarPage", { pagination: { page }, filter });
}

function deleteOneMateAvatar(id) {
  return deleteOne(`/MateAvatar/${id}`);
}

function createOneMateAvatar(params) {
  return post("/MateAvatar/0", params);
}

function readMateTone(page?: number): Promise<PageResponse<MateTone>> {
  return get("/MateTonePage", { pagination: { page, perPage: 999 } });
}

function readMateToneCategoryPage(
  page?: number
): Promise<PageResponse<MateToneCategory>> {
  return get("/MateToneCategoryPage", { pagination: { page, perPage: 999 } });
}

function readBgmTone(page?: number): Promise<PageResponse<MateTone>> {
  return get("/GalGameBgmPage", { pagination: { page: 1, perPage: 999 } });
}

function createOneMate(data: Partial<Mate> = {}): Promise<WriteResponse<Mate>> {
  return post("/Mate/0", data);
}

function readMateAdmiringPage(
  params: PageRequest<null>
): Promise<PageResponse<Mate>> {
  return get("/Mate/ReadAdmiringPage", params);
}

function deleteOneMate(uuid: string): Promise<null> {
  return deleteOne(`/Mate/${uuid}`);
}

function playTextAudio(
  params: {
    mateToneId: number;
    text: string;
    mateToneConfig?: MateToneConfig;
  },
  config = {}
): Promise<WriteResponse<TextAudio>> {
  return post("/TextAudio/0", params, config);
}

function publishOneMate(
  uuid: string,
  isSynctoInteractionPool: boolean = false
): Promise<WriteResponse<Mate>> {
  return put(`/MatePublish/${uuid}`, { isSynctoInteractionPool });
}

function updateMate(
  uuid: string,
  params: Partial<
    Pick<
      Mate,
      | "name"
      | "mediaUrl"
      | "dtPublish"
      | "gender"
      | "mediaId"
      | "personalityPrompt"
      | "personalityDescription"
      | "mateToneId"
      | "languageId"
      | "relation"
      | "job"
    >
  >,
  cb?: (progress: number) => void
) {
  if (cb === undefined) {
    return put(`/Mate/${uuid}`, params);
  }

  return fetchStream(`/Mate/${uuid}`, "PUT", params, cb);
}

export type UpdateMateDetailParams = Partial<Mate>;

function updateMateDetail(
  uuid: string,
  params: UpdateMateDetailParams
): Promise<WriteResponse<Mate>> {
  return put(`/MateDetail/${uuid}`, params);
}

function generateMateDescription(uuid, cb) {
  return fetchStream(`/MateDescription/${uuid}`, "PUT", {}, cb);
}

function readOneMate(uuid: string): Promise<WriteResponse<Mate>> {
  return get(`/Mate/${uuid}`);
}

function readMatePersonalityPrompt() {
  return get("/MatePromptPage");
}

function readMediaPage(params) {
  return get("/MediaPage", params);
}

function readPresetMatePromptPage(params: {
  keyword?: string;
  pagination?: {
    page?: number;
    perPage?: number;
  };
}) {
  return get("/PresetMatePromptPage", params);
}

function readMateMediaPage(
  params: CursorPageRequest<{
    mateId?: number;
    type?: 1 | 2 | 3;
  }>
): Promise<CursorPageResponse<MateMedia>> {
  return get("/MateMediaPage", params);
}

function deleteMateMedia(id: number): Promise<void> {
  return deleteOne(`/MateMedia/${id}`);
}

function updateMateMedia(
  id: number,
  params: {
    name?: string;
    visibility?: VisibilityStatus;
    crystalPrice?: number;
  }
): Promise<void> {
  return put(`/MateMedia/${id}`, params);
}

function createOneMateMedia(params: {
  mediaId: number;
  type: MediaResourceType;
}): Promise<WriteResponse<MateMedia>> {
  return post("/MateMedia/0", params);
}

function updateOneMateMedia(
  id: number,
  name: string
): Promise<WriteResponse<MateMedia>> {
  return put("/MateMedia/" + id, { name });
}

function createOrUpdateManyMateMedia(
  itemzz: {
    mediaId: number;
    visibility: VisibilityStatus;
    crystalPrice?: number;
  }[]
): Promise<WriteResponse<MateMedia>> {
  return post("/MateMedia/UpsertMany", { itemzz });
}

function readModuleMediaPage(
  params: CursorPageRequest<{
    entityId: number;
    entityType: ModuleEntityType;
    type?: MediaResourceType;
  }>
): Promise<CursorPageResponse<ModuleMedia>> {
  return get("/ModuleMediaPage", params);
}

function createOneModuleMedia(params: {
  entityId: number;
  entityType: ModuleEntityType;
  mediaId: number;
  type: MediaResourceType;
}): Promise<WriteResponse<ModuleMedia>> {
  return post("/ModuleMedia", params);
}

function deleteOneModuleMedia(id: number): Promise<void> {
  return deleteOne(`/ModuleMedia/${id}`);
}

async function uploadMedia(
  type: MediaType,
  file: File,
  entityId = 0
): Promise<WriteResponse<Media>> {
  // if (import.meta.env.DEV && import.meta.env.VITE_UPLOAD_CDN) {
  //   return post(
  //     "/Media/0",
  //     { file, type, entityId },
  //     { headers: { "Content-Type": "multipart/form-data" } }
  //   );
  // }

  const res = await post("/OssToken", { type, entityId });

  const { maxSize, allowExtensions, config } = res.data;
  const ext =
    file.name.lastIndexOf(".") === -1
      ? ""
      : file.name.substring(file.name.lastIndexOf(".")).toLowerCase();

  if (file.size > maxSize) {
    throw new Error(
      i18n.global.t("Media.fileSizeExceed", {
        size: maxSize / 1024 / 1024,
      })
    );
  }

  if (!allowExtensions.includes(ext.substring(1))) {
    throw new Error(
      i18n.global.t("Media.fileFormatDisallowed", {
        extension: allowExtensions.join(", "),
      })
    );
  }

  const data: Record<string, any> = {
    OSSAccessKeyId: config.accessId,
    policy: config.policy,
    signature: config.signature,
    callback: config.callback,
    key: config.pathPrefix + ext,
    file,
  };
  Object.assign(data, config.callbackVar);
  const ossRes = await axios.post(config.host, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  if (!ossRes.data.item)
    throw new Error(i18n.global.t(`Message.uploadNotAllow`));
  return ossRes.data;
}

async function uploadNsfwMedia(
  type: MediaType,
  file: File,
  entityId = 0,
  allowNsfw = 0
): Promise<WriteResponse<Media>> {
  if (import.meta.env.DEV && import.meta.env.VITE_UPLOAD_CDN === "1") {
    return post(
      "/Media/0",
      { file, type, entityId },
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  }
  return post(
    "/Media/UploadOne/0",
    { file, allowNsfw },
    { headers: { "Content-Type": "multipart/form-data" } }
  );
}

function createOneMateStyle(mediaId, mediaUrl, chatMessageSavepoint, name) {
  return post("/MateStyle/0", {
    mediaId,
    mediaUrl,
    chatMessageSavepoint,
    name,
  });
}

function deleteOneMateStyle(id) {
  return deleteOne(`/MateStyle/${id}`);
}

function readMateStylePage(params) {
  return get("MateStylePage", params);
}

function updateHint(type, text, cb) {
  // return post(`/Hint/0`, { type, text }

  return fetchStream(`/Hint/0`, "POST", { type, text }, cb);
}

function readMatePage(
  params: PageRequest<{
    state?: MateStatus;
    parentId?: number;
    userId?: number;
    chatMessageSavepoint?: string; // uuid
    currentWorldviewId?: number;
    type?: MateType;
  }> = {}
): Promise<PageResponse<Mate>> {
  return get("/MatePage", params);
}

function readAiMatePage(
  params: PageRequest<{
    excludeLinked?: number;
    type?: MateType;
  }> = {}
): Promise<PageResponse<Mate>> {
  return get("/Mate/ReadPresetAiPage", params);
}

// Route::get('/MateLinkPage', \App\Api\MateLink\ReadPage\ReadMateLinkPageController::class)->middleware(['auth']);
// Route::post('/MateLink', \App\Api\MateLink\CreateOne\CreateOneMateLinkController::class)->middleware(['auth']);
// Route::put('/MateLink/{id}', \App\Api\MateLink\UpdateOne\UpdateOneMateLinkController::class)->middleware(['auth']);
// Route::delete('/MateLink/{id}', \App\Api\MateLink\DeleteOne\DeleteOneMateLinkController::class)->middleware(['auth']);
// Route::post('/MateLink/ImportMany', \App\Api\MateLink\ImportMany\ImportManyMateLinkController::class)->middleware(['auth']);

function readMateLinkPage(
  params: PageRequest<{
    isActive?: boolean;
  }>
): Promise<PageResponse<MateLink>> {
  return get("/MateLinkPage", params);
}

function createOneMateLink(params: {
  targetMateId: number;
}): Promise<WriteResponse<MateLink>> {
  return post("/MateLink", params);
}

function updateOneMateLink(
  id: number,
  params: {
    isActive?: boolean;
  }
): Promise<WriteResponse<MateLink>> {
  return put(`/MateLink/${id}`, params);
}

function deleteOneMateLink(id: number): Promise<WriteResponse<MateLink>> {
  return deleteOne(`/MateLink/${id}`);
}

function importManyMateLink(params: {
  mateIdzz: number[];
}): Promise<ItemResponse<MateLink>> {
  return post("/MateLink/ImportMany", params);
}

function readSavePointPage(filter, pagination) {
  return get("/ChatMessageSavepointPage", {
    filter,
    sort: { field: "id", order: "desc" },
    pagination,
  });
}

function updateSavePoint(uuid, params, cb) {
  const uri = `/ChatMessageSavepoint/${uuid}`;
  if (cb) {
    return fetchStream(uri, "PUT", params, cb);
  }
  return put(uri, params);
}

function generateSavePointDescription(uuid, cb) {
  return fetchStream(`/ChatMessageSavepointDescription/${uuid}`, "PUT", {}, cb);
}

function forkSavepoint(uuid) {
  return post(`/ChatMessageSavepoint/0`, { parent: uuid });
}

function readOneSavePoint(uuid) {
  return get(`/ChatMessageSavepoint/${uuid}`);
}

function readSavePointTree(uuid) {
  return get(`/ChatMessageSavepointTree/${uuid}`);
}

function readChatMessageSavepointTreePage(params) {
  return get("/ChatMessageSavepointTreePage", params);
}

function updateManyChatMessage(idzz, styleId) {
  return put("/ChatMessage", { idzz, styleId });
}

function createOneChatMessage(params, cb) {
  params.stream = true;
  return fetchStream(`/ChatMessage/0`, "POST", params, cb);
}

function createChatMessageQuestion(params, cb) {
  return fetchStream(`/ChatMessageQuestion`, "POST", params, cb);
}

function createChatMessageSummary(params, cb) {
  return fetchStream(`/ChatMessageSummary`, "POST", params, cb);
}

function createOnePublishPoint(data) {
  return post("/PublishPoint/0", data);
}

function readChatMessagePage(
  params: PageRequest<{
    chatSession: number;
  }>
): Promise<PageResponse<ChatMessage>> {
  return get("/ChatMessagePage", params);
}

function createOneChatSession(uuid, params) {
  return post(`/ChatSession/${uuid}`, params);
}

function readOneChatSessionBy(uuid) {
  return get(`/ChatSession/${uuid}`);
}

function deleteSavePoint(uuid) {
  return deleteOne(`/ChatMessageSavepoint/${uuid}`);
}

function readChatSessionPage(uuid) {
  return get(`/ChatSession/${uuid}`);
}

function updateChatMessage(
  id: number,
  params: {
    dtIgnore?: string | null;
    text?: string;
    mediaId?: number;
    mediaUrl?: string;
    envMediaId?: number;
  }
): Promise<WriteResponse<ChatMessage>> {
  return put(`/ChatMessage/${id}`, params);
}

function deleteOneChatMessage(id: number) {
  return deleteOne(`/ChatMessage/${id}`);
}

function updateOneChatMessageAudio(id: number, config = {}) {
  return put(`/ChatMessageAudio/${id}`, {}, config);
}

function updateOneChatMessageScene(
  mateSessionId: number
): Promise<WriteResponse<ChatMessage>> {
  return put(`/ChatMessageScene/0`, { mateSessionId });
}

function updateOneChatMessageFace(
  id: ChatMessage["id"]
): Promise<WriteResponse<ChatMessage>> {
  return put(`/ChatMessage/DrawFace/${id}`);
}

function readAllChatSessionPage(params) {
  return get("/ChatSessionPage", params);
}

function deleteOneChatSession(uuid) {
  return deleteOne(`/ChatSession/${uuid}`);
}

function readChatMessageCount(): Promise<
  Response<Pick<ChatMate, "mateId" | "unreadCount">[]>
> {
  return get("/ChatMessageCount");
}

function signOut() {
  return deleteOne("/Auth");
}

function deleteImpersonate() {
  return deleteOne("/Impersonation");
}

// Chage Language
function changeLanguage(params) {
  return put("/UserHome", params);
}

async function updateUser(params: Partial<User>): Promise<WriteResponse<User>> {
  const res = await put("/UserHome", params);
  StorageSet("user", res.item);
  sessionStorageSet("user", res.item);
  return res;
}

async function bindEmail(params: {
  email: string;
  code: number;
}): Promise<WriteResponse<User>> {
  return post("/User/BindEmail", params);
}

async function bindPhone(params: {
  phone: string;
  code: number;
}): Promise<WriteResponse<User>> {
  return post("/User/BindPhone", params);
}

async function UserInvitationCodeCheck(params: {
  code: string;
}): Promise<Response<{ inviter: Mate; isValid: boolean }>> {
  return get("/UserInvitationCodeCheck", params);
}

async function getAllSubscription() {
  return get("/Subscription/ReadAll");
}

// get Language

function getLanguage() {
  return get("/UserHome");
}

// delete Message
function deleteMsg(id) {
  return deleteOne(`/ChatMessage/${id}`);
}

// Savepoint Tree
function getSavepointTree(uuid) {
  return get(`/ChatMessageSavepointTree/${uuid}`);
}

function readReplyPage(
  params: PageRequest<{
    rootId: number;
  }>
): Promise<PageResponse<Reply>> {
  return get("/ReplyPage", params);
}

function readReplyTreePage(
  params: PageRequest<{
    entityId: number;
    entityType: "App\\Models\\StoryBook" | "App\\Models\\Collection";
  }>
): Promise<PageResponse<Reply>> {
  return get("/Reply/ReadTreePage", params);
}

interface PostReplyParams {
  mateId: string; // uuid
  content: string;
  parentId: number;
  mediaIdzz?: number[];
  mentionMateIdzz?: string[];
}

function createOneReply(
  params: PostReplyParams
): Promise<WriteResponse<Reply>> {
  return post("/Reply/0", params);
}

function updateOneReply(
  id: number,
  params: PostReplyParams
): Promise<WriteResponse<Reply>> {
  return put("/Reply/" + id, params);
}

function deleteReply(id: number): Promise<WriteResponse<null>> {
  return deleteOne(`/Reply/${id}`);
}

function readEmojiPage(): Promise<PageResponse<Emoji>> {
  return get("/EmojiPage");
}

/** 新建-返回EmojiVote，删除-返回null */
function createEmojiVote(params: {
  emojiId: number;
  replyId: number;
  mateId: string; // mate.uuid
}): Promise<WriteResponse<EmojiVote>> {
  return post("/EmojiVote/0", params);
}

function readCommentPage(params) {
  return get("/CommentPage", params);
}

function readNotificationPage(
  params: ReadNotificationPageRequest
): Promise<CursorPageResponse<Notification<NotifyData>>> {
  return get("/NotificationPage", params);
}

function readNotificationSummary(role: Role = "mates"): Promise<
  Response<{
    unreadNum: number;
  }>
> {
  return get("/NotificationSummary", { role });
}

function changeNotificationRead(
  uuid: string,
  role: Role = "mates"
): Promise<Response<null>> {
  return post(`/NotificationRead/${uuid}?role=${role}`);
}

function changeNotificationReadAll(
  role: Role = "mates"
): Promise<Response<null>> {
  return post(`/NotificationReadAll?role=${role}`);
}

/** 读取推荐FEED */
function readMomentExplorePage(
  params: CursorPageRequest<{ type?: "video" | "story" | "game" }>
): Promise<CursorPageResponse<Moment>> {
  return get("/MomentExplorePage", params);
}

/** 读取关注FEED */
function readMomentFollowingPage(
  params: CursorPageRequest<null>
): Promise<CursorPageResponse<Moment>> {
  return get("/MomentPage", {
    ...params,
    sort: {
      field: "dtCreate",
      order: "desc",
    },
  });
}

function readMomentFriendsPage(
  params: CursorPageRequest<{ filter: 2 | 3 }>
): Promise<CursorPageResponse<Moment>> {
  return get("/MomentFriendsPage", params);
}

function readMomentPage(
  params: CursorPageRequest<{
    mateId: number;
    rootId?: number;
    status?: "published" | "draft";
    keyword?: string;
    excludeCollectionId?: number;
  }>
): Promise<CursorPageResponse<Moment>> {
  return get("/MateMomentPage", params);
}

function readTreeholeMomentPage(
  params: CursorPageRequest<{
    mateId?: number;
    status?: 1 | 2;
  }>
): Promise<CursorPageResponse<Moment>> {
  return get("/Moment/ReadTreeHolePage", params);
}

export interface PostMomentParams {
  mateId: string; // uuid
  status?: Moment["status"]; // 1-发布; 2-草稿
  text?: string;
  mediaIdzz?: number[];
  messageIdzz?: number[];
  mentionMateIdzz?: string[];
  visibility?: Visibility;
  parentId?: number; // uuid
  roleplayAnswerId?: number;
  collectionId?: number;
  storyId?: number;
  galGameId?: number;
  storyGameId?: number;
  collectionIdzz?: number[];
  isAiGenerated?: boolean;
  audioMediaId?: number;
  canUnlinkedAiInteract?: boolean;
  type?: 1 | 2; // 1-饼友圈；2-树洞
}

function createMoment(
  params: PostMomentParams
): Promise<WriteResponse<Moment>> {
  return post("/Moment", params);
}

function updateMoment(
  uuid: string,
  params: PostMomentParams
): Promise<WriteResponse<Moment>> {
  return put("/Moment/" + uuid, params);
}

function postMomentComplete(
  params: {
    mateId: number;
    content: string;
    type: MateCardFactoryGenerateType;
    journalIdzz?: number[];
    mailIdzz?: number[];
    dispatchIdzz?: number[];
    memoryIdzz?: number[];
  },
  cb: (content: Response<{ text: string }> | string) => void
) {
  return fetchStream(`/MomentComplete`, "POST", params, cb);
}

function readOneMoment(uuid: string): Promise<WriteResponse<Moment>> {
  return get(`/Moment/${uuid}`);
}

function deleteOneMoment(uuid: string): Promise<WriteResponse<null>> {
  return deleteOne(`/Moment/${uuid}`);
}

function createOneFollower(mateId: number): Promise<WriteResponse<Follower>> {
  return post(`/MateFollower/${0}`, { mateId });
}

function deleteOneFollower(recordId: number): Promise<WriteResponse<null>> {
  return deleteOne(`/MateFollower/${recordId}`);
}

function readFollowerPage(
  params: PageRequest<{
    mateId?: number;
    fanId?: number;
  }>
): Promise<PageResponse<Follower>> {
  return get(`/MateFollowerPage`, params);
}

function createOneAdmirer(mateId: number): Promise<WriteResponse<Admirer>> {
  return post(`/MateAdmirer/${0}`, { mateId });
}

function createOneAdmirerRequest(
  senderId: number,
  receiverId: number
): Promise<WriteResponse<Admirer>> {
  return post(`/MateAdmireRequest`, { senderId, receiverId });
}

function deleteOneAdmirer(recordId: number): Promise<WriteResponse<null>> {
  return deleteOne(`/MateAdmirer/${recordId}`);
}

function readAdmirerPage(
  params: PageRequest<{
    mateId?: number;
    fanId?: number;
  }>
): Promise<PageResponse<Admirer>> {
  return get(`/MateAdmirerPage`, params);
}

function readAdmireSubscriptionPage(
  params: PageRequest<{
    admirerId?: number;
    recipientId?: number;
    type?: number;
    status?: number;
  }>
): Promise<PageResponse<Admirer>> {
  return get(`/AdmireSubscriptionPage`, params);
}

function reviewAdmirer(id: number, status: "accepted" | "rejected") {
  return post(`/MateAdmireRequestReview/${id}`, { status });
}

function readAdmirerRequestPage(
  params: PageRequest<{
    mateId?: number;
    receiverId?: number;
    role?: "sender" | "receiver";
    status: "pending" | "finished";
  }>
): Promise<PageResponse<AdmirerCommit>> {
  return get(`/MateAdmireRequestPage`, params);
}

function readMateSessionPage(
  params: PageRequest<{
    mateId?: number;
    isPrivate?: 0 | 1; // 0-公开 1-私密
  }>
): Promise<PageResponse<MateSession>> {
  return get(`/MateSessionPage`, params);
}

function readMateSessionByMateId(
  mateId: number
): Promise<WriteResponse<MateSession>> {
  return get(`/MateSession`, { id: mateId });
}

function createOneMateSession(
  mateId: number,
  isPrivate?: 0 | 1, // 0-公开 1-私密
  chatSceneId?: number,
  matePersonaId?: number,
  myMateId?: number
): Promise<WriteResponse<MateSession>> {
  return post(`/MateSession/${0}`, {
    mateId,
    isPrivate,
    chatSceneId,
    matePersonaId,
    myMateId,
  });
}

function readOneMateSession(id: number): Promise<WriteResponse<MateSession>> {
  return get(`/MateSession/${id}`);
}

function updateMateSessionMode(
  id: number,
  params: { mode: SessionMode }
): Promise<WriteResponse<MateSession>> {
  return put(`/MateSessionSetMode/${id}`, params);
}

function deleteOneMateSession(id: number): Promise<WriteResponse<null>> {
  return deleteOne(`/MateSession/${id}`);
}

function updateOneMateSession(
  id: number,
  params: Partial<
    Pick<
      MateSession,
      | "title"
      | "mediaId"
      | "autoPlayAudio"
      | "bgMediaId"
      | "isNsfw"
      | "model"
      | "matePersonaId"
      | "mateToneId"
      | "narratorToneId"
    >
  >
): Promise<WriteResponse<MateSession>> {
  return put(`/MateSession/${id}`, params);
}

function updateChatStatus(id: number) {
  return post(`/MateSession/ChatStatus/${id}`);
}

function createOneMateMessage(
  params: {
    text: string;
    mateSessionId: number;
    type: InputTypeEnum;
    isRegenerate?: boolean;
    timeInterval?: number;
    timeUnit?: "minute" | "hour" | "day" | "week";
    fromName?: string;
    toNames: string[];
    temperature?: number;
    characterAction?: {
      type: InputTypeEnum;
      targetPositionId?: number;
      targetCharacterId?: number;
    };
    needReplyMessage?: boolean;
    recipientCharacterIds?: number[];
    currentTime?: string;
  },
  callback: (content: Response<ChatMessage> | string) => void
): Promise<void> {
  return fetchStream(`/MateMessage/0`, "POST", params, callback);
}

function readMateMessagePage(
  params: CursorPageRequest<{
    mateSessionId: number;
  }>
): Promise<CursorPageResponse<ChatMessage>> {
  return get(`/MateMessagePage`, params);
}

function readMateCommitPage(
  params: PageRequest<{
    status?: "pending" | "finished";
    role?: "creator" | "receiver";
  }>
): Promise<PageResponse<MateCommit>> {
  return get(`/MomentCommitPage`, params);
}

function createOneMateCommit(params: {
  mateId: string; // uuid
  toMateId: string; // uuid
  title: string;
  text: string;
  mediaIdzz: number[];
  messageIdzz: number[];
}): Promise<WriteResponse<MateCommit>> {
  return post(`/MomentCommit`, params);
}

function reviewMateCommit(
  commitId: number,
  reviewStatus: MateCommitStatus
): Promise<WriteResponse<MateCommit>> {
  return post(`/MomentCommitReview/${commitId}`, { status: reviewStatus });
}

function readModulePage(): Promise<PageResponse<Module>> {
  return get("/ModulePage");
}

function createOneModule(name: string): Promise<WriteResponse<Module>> {
  return post("/Module/0", { name });
}

function deleteOneModule(
  id: number,
  entityId: number,
  entityType: ModuleEntityType
): Promise<WriteResponse<null>> {
  return deleteOne(
    `/Module/${id}?entityId=${entityId}&entityType=${entityType}`
  );
}

function updateOneModule(
  id: number,
  name: string
): Promise<WriteResponse<Module>> {
  return put(`/Module/${id}`, { name });
}

function readModuleQuestionPage(
  params: PageRequest<{
    mateModuleId: number | number[];
    entityUuid: string;
    entityType: ModuleEntityType;
  }>
): Promise<PageResponse<ModuleQuestion>> {
  return get("/ModuleQuestionPage", params);
}

function createOneModuleQuestion(params: {
  mateModuleId: number;
  text: string;
  fieldType?: number; // 6 关系
  entityType?: ModuleEntityType;
}): Promise<WriteResponse<ModuleQuestion>> {
  return post("/ModuleQuestion/0", params);
}

function deleteOneModuleQuestion(
  id: number,
  entityId: number,
  entityType: ModuleEntityType
): Promise<WriteResponse<null>> {
  return deleteOne(
    `/ModuleQuestion/${id}?entityId=${entityId}&entityType=${entityType}`
  );
}

function updateOneModuleQuestion(
  id: number,
  name: string
): Promise<WriteResponse<ModuleQuestion>> {
  return put(`/ModuleQuestion/${id}`, { text: name });
}

function readMateModulePage(
  params: PageRequest<{
    entityUuid?: string;
    entityType?: string;
  }>
): Promise<{
  page: {
    current_page: number;
    data: MateModule[];
    path: string;
    per_page: number;
    total?: number;
    additional: {
      entities: {
        storyBook: StoryBook[];
        mate: Mate[];
      };
    };
  };
}> {
  return get("/MateModulePage", {
    ...params,
    pagination: { page: 1, perPage: 999 },
  });
}

function createOneMateModule(params: {
  entityId: number;
  entityType: ModuleEntityType;
  name: string;
}): Promise<WriteResponse<MateModule>> {
  return post("/MateModule/0", params);
}

function deleteOneMateModule(
  id: number,
  entityId: number,
  entityType: ModuleEntityType
): Promise<WriteResponse<null>> {
  return deleteOne(
    `/MateModule/${id}?entityId=${entityId}&entityType=${entityType}`
  );
}

function updateOneMateModule(
  id: number,
  params: Pick<MateModule, "answerMap">
): Promise<WriteResponse<MateModule>> {
  return put(`/MateModule/${id}`, params);
}

function readTextImagePage(
  params: CursorPageRequest<{
    status?: 0 | 1 | -1; // 0-待标记 1-优质 -1-废弃 undefined-等待中
    id?: number;
  }>
): Promise<CursorPageResponse<TextImage>> {
  return get("/TextImagePage", params);
}

function readTextImageByUuid(uuid: string): Promise<WriteResponse<TextImage>> {
  return get(`/TextImage/${uuid}`);
}

function readUnmarkedTaskCount(): Promise<
  Response<{ waitingMarkCount: number }>
> {
  return get("/TaskSummary");
}

function updateOneTextImage(
  id: number,
  params: {
    status: TextImage["status"];
    dtPublish?: TextImage["dtPublish"];
  }
): Promise<WriteResponse<TextImage>> {
  return put(`/TextImage/${id}`, params);
}

function createOneTextImageTask(params: {
  sourceId: number;
  mode: TextImageModeEnum;
}): Promise<WriteResponse<TextImage>> {
  return post("/TextImageTask", removeMedia(params));
}

function createOneTextImage(params: PromptJson): Promise<WriteResponse<Media>> {
  formatStyle(params as any);
  return post("/TextImage", removeMedia({ ...params }));
}

function createOneTextImageTrait(
  params: PromptJson
): Promise<WriteResponse<Media>> {
  formatStyle(params as any);
  return post("/TextImage/GenerateTrait", removeMedia({ ...params }));
}

function readImagePromptPage(
  params: PageRequest<null>
): Promise<PageResponse<ImagePrompt>> {
  return get("/ImagePromptPage", params);
}

function createOneTextGifTask(params: {
  prompt?: string;
  sourceId: number;
  style?: number;
  mateTraitId?: number;
}): Promise<WriteResponse<TextImage>> {
  return post("/TextImageGif", params);
}

function createOneMediaExtend(
  mediaId: number,
  tab: TaskTab
): Promise<WriteResponse<TextImage>> {
  return put("/MediaExtend/" + mediaId, { tab });
}

// Mate特征
function createOneMateTrait(params: {
  name: string;
  sourceId?: number;
  prompt: string;
  negativePrompt?: string;
  style: number;
  mateId?: number;
}): Promise<WriteResponse<MateTrait>> {
  return post("/MateTrait/0", params);
}

export const cloneMateTrait = (id: number): Promise<WriteResponse<MateTrait>> =>
  post(`/MateTraitClone/${id}`);

function updateOneMateTrait(
  id: number,
  params: Partial<Pick<MateTrait, "name" | "style" | "prompt" | "sourceId">>
): Promise<WriteResponse<MateTrait>> {
  return put(`/MateTrait/${id}`, params);
}

function readMateTraitPage(
  params: PageRequest<{
    mateId?: number;
    id?: number;
  }>
): Promise<PageResponse<MateTrait>> {
  return get("/MateTraitPage", params);
}

function deleteOneMateTrait(id: number): Promise<WriteResponse<null>> {
  return deleteOne(`/MateTrait/${id}`);
}

// portrait

function readMateTraitPortraitPage(
  params: PageRequest<{
    id?: number;
    mateId?: number;
    mateTraitId?: number;
  }>
): Promise<PageResponse<MatePortrait>> {
  return get("/MateTraitPortraitPage", params);
}

function createOneMateTraitPortrait(
  params: MateTraitPortraitParams
): Promise<WriteResponse<MateTraitMedia>> {
  return post("/MateTraitPortrait", params);
}

function deleteOneMateTraitPortrait(id: number): Promise<WriteResponse<null>> {
  return deleteOne(`/MateTraitPortrait/${id}`);
}

function updateOneMateTraitPortrait(
  id: number,
  params: MateTraitPortraitParams
): Promise<WriteResponse<MateTraitMedia>> {
  return put(`/MateTraitPortrait/${id}`, params);
}

// 提取特征
export const featureExtraction = (
  mediaId: number
): Promise<Response<{ prompt: string }>> =>
  post(`/SD/InterrogateImage`, { mediaId });

// 提取特征
export const removeImageBackground = (
  mediaId: number
): Promise<Response<Media>> => post(`/SD/RemoveImageBackground`, { mediaId });

function readStoryPage(
  params: PageRequest<{
    mateId?: number;
    published?: 0 | 1;
    storyBook?: number;
    storyId?: number;
  }>
): Promise<PageResponse<Story>> {
  return get("/StoryPage", params);
}

function putStorySort(itemzz: { id: number; order: number }[]) {
  return put(`/StorySort`, { itemzz });
}

function readOneStory(uuid: string): Promise<WriteResponse<Story>> {
  return get(`/Story/${uuid}`);
}

function createOneStory(params: {
  storyBookId: number;
  mediaId: number;
  title: string;
  description: string;
  mateId: number;
}): Promise<WriteResponse<Story>> {
  return post("/Story/0", params);
}

function updateOneStory(
  id: number,
  params: Partial<
    Pick<
      Story,
      "title" | "description" | "mediaId" | "dtPublish" | "text" | "mateToneId"
    >
  >
): Promise<WriteResponse<Story>> {
  return put(`/Story/${id}`, params);
}

function deleteOneStory(id: number): Promise<Response<Story>> {
  return deleteOne(`/Story/${id}`);
}

function storyGenerate(
  params: StoryGenerateParams
): Promise<WriteResponse<Story>> {
  return post("/StoryGenerate", params);
}

function storyWriteGenerate(
  params: StoryGenerateParams,
  callback: <T>(content: Response<T> | string) => void | Promise<void>
) {
  return fetchStream(`/StoryWriteGeneration`, "POST", params, callback);
}

function storyDuplicate(id: number): Promise<WriteResponse<Story>> {
  return post(`/StoryDuplicate/${id}`);
}

function storyWrite(params: {
  storyId: number;
  momentId?: number;
  momentText?: string;
  storyText?: string;
}): Promise<
  WriteResponse<{
    text: string;
  }>
> {
  return post("/StoryWrite/0", params);
}

function storyImageGeneration(body: {
  text: string;
  traitId?: number;
  imageStyle?: number;
  prompt?: string;
}) {
  return post(`/StoryImageGenerate`, body);
}

function storyPromptExtract(body: { text: string }) {
  return post(`/StoryPromptExtract`, body);
}

function readStoryChapterPage(
  params: PageRequest<{
    storyId: number;
  }>
): Promise<PageResponse<StoryChapter>> {
  return get("/StoryChapterPage", params);
}

function createOneStoryChapter(params: {
  storyId: number;
  momentId: number;
}): Promise<WriteResponse<StoryChapter>> {
  return post("/StoryChapter/0", {
    ...params,
    title: "",
    text: "",
  });
}

function deleteOneStoryChapter(id: number): Promise<WriteResponse<null>> {
  return deleteOne(`/StoryChapter/${id}`);
}

function updateOneStoryChapter(
  id: number,
  params: Partial<Pick<StoryChapter, "momentId">>
): Promise<WriteResponse<StoryChapter>> {
  return put(`/StoryChapter/${id}`, params);
}

function storyScreenshot(uuid: string): Promise<WriteResponse<Media>> {
  return post(`/StoryScreenshot/${uuid}`);
}

function createOneStoryVideo(param: {
  storyId: number;
  isAudio: 0 | 1;
  mateToneId: number;
  toneMood: number;
}): Promise<WriteResponse<StoryVideo>> {
  return post("/StoryVideo/0", param);
}

function readStoryBookPage(
  params: PageRequest<{
    mateId?: number;
    published?: 0 | 1;
  }>
): Promise<PageResponse<StoryBook>> {
  return get("/StoryBookPage", params);
}

function createOneStoryBook(params: {
  mediaId?: number;
  title: string;
  description: string;
  visibility: Visibility;
  mateId?: number;
}): Promise<WriteResponse<StoryBook>> {
  return post("/StoryBook/0", params);
}

function readOneStoryBook(uuid: string): Promise<WriteResponse<StoryBook>> {
  return get(`/StoryBook/${uuid}`);
}

function readStoryBookPoplarPage(params: {
  pagination: {
    page: number;
    perPage: number;
  };
  tab: "hot" | "new" | "my";
}) {
  return get("/StoryBook/ReadPopularPage", params);
}

function readMatePopularPage(params: {
  pagination: {
    page: number;
    perPage: number;
  };
  tab: "hot" | "new" | "my";
}): Promise<PageResponse<Mate>> {
  return get("/Mate/ReadPopularPage", params);
}

function readMateListByUserMateId(
  userMateUuid: string
): Promise<ItemResponse<Mate>> {
  return get(`/Mate/ReadAll/${userMateUuid}`);
}

function updateOneStoryBook(
  id: number,
  params: {
    mediaId?: number;
    title?: string;
    description?: string;
    dtPublish?: string;
    visibility?: Visibility;
    collectionIdzz?: number[];
  }
): Promise<WriteResponse<StoryBook>> {
  return put(`/StoryBook/${id}`, params);
}

function deleteOneStoryBook(id: number): Promise<WriteResponse<null>> {
  return deleteOne(`/StoryBook/${id}`);
}

function storyBookImportStory(
  storyBookId: number,
  storyIds: number[]
): Promise<WriteResponse<null>> {
  return post(`/StoryBookImportStory/${storyBookId}`, { storyIdzz: storyIds });
}

function readMatePopular(): Promise<ItemResponse<MatePopular>> {
  return get("/MatePopular");
}

function readMateSearchPage(
  params: PageRequest<{
    query: string;
    searchFields?: MateSearchableFields[];
    isNsfw?: 0 | 1;
    isProfileSet?: 0 | 1;
  }> & { tab?: MateSearchSorterEnum }
): Promise<PageResponse<Mate>> {
  return get("/MateSearchPage", params);
}

function readMomentSearchPage(
  params: PageRequest<{
    query: string;
  }> & { tab?: SorterEnum }
): Promise<PageResponse<Moment>> {
  return get("MomentSearchPage", params);
}

function readTaskPage(
  params: CursorPageRequest<{
    status?: TaskStatus; // 0-待标记 1-优质 -1-废弃 undefined-等待中
    id?: number;
    entityType?: TaskEntityType;
    storyId?: number;
    statusList?: TaskStatus[];
    tab?: TaskTab;
  }>
): Promise<CursorPageResponse<Task>> {
  return get("/TaskPage", params);
}

function updateOneTask(
  id: number,
  params: {
    status: Task["status"];
    copyToAlbum?: 0 | 1;
  }
): Promise<WriteResponse<Task>> {
  return put(`/Task/${id}`, params);
}

function deleteOneTask(id: number): Promise<Response<Task>> {
  return deleteOne(`/Task/${id}`);
}

function retryTask(id: number): Promise<Response<Task>> {
  return post(`/TaskRetry/${id}`);
}

function createOnePageView(params: {
  replyId: number;
}): Promise<Response<Reply>> {
  return post("/PageView/0", params);
}

function inpaintImage(param: {
  mediaId: number;
  prompt?: string;
  type: InpaintType;
  imageStyle?: number;
  maskBase64?: string;
  strength?: number;
  removeBackground?: boolean;
}): Promise<Response<Media>> {
  return post("/SD/InpaintImage", param);
}

function mediaReplace(targetMediaId: number, params: { sourceId: number }) {
  return put(`/MediaReplace/${targetMediaId}`, params);
}

function updateTextImage(
  uuid: string,
  params: { mediaId: number; isNotShown: boolean }
) {
  return put(`/TextImage/${uuid}`, params);
}

function createOneChatSample(params: {
  title?: string;
  userText: string;
  mateText: string;
}): Promise<WriteResponse<ChatSample>> {
  return post("/ChatSample/0", params);
}

function updateOneChatSample(
  id: number,
  params: {
    title?: string;
    userText: string;
    mateText: string;
  }
): Promise<WriteResponse<ChatSample>> {
  return put(`/ChatSample/${id}`, params);
}

function deleteOneChatSample(id: number): Promise<WriteResponse<null>> {
  return deleteOne(`/ChatSample/${id}`);
}

function readChatSamplePage(
  params: PageRequest<never>
): Promise<PageResponse<ChatSample>> {
  return get("/ChatSamplePage", params);
}

function readMateTraitMediaPage(
  params: CursorPageRequest<{
    mateSessionId: number;
  }>
): Promise<CursorPageResponse<MateTraitMedia>> {
  return get("/MateTraitMediaPage", params);
}

function createOneMateTraitAnimation(param: {
  mateTraitId: number;
  name: string;
  type: TraitAnimationType;
  portraitzz: ({ type: TraitAnimationPortraitType } & MatePortrait)[];
}): Promise<WriteResponse<MateTraitAnimation>> {
  return post("/MateTraitAnimation", param);
}

function readMateTraitAnimationPage(
  params: PageRequest<{
    mateTraitId?: number;
    id?: number;
    type?: TraitAnimationType;
    mateId?: number;
  }>
): Promise<PageResponse<MateTraitAnimation>> {
  return get("/MateTraitAnimationPage", params);
}

function readOneMateTraitAnimation(
  id: number
): Promise<WriteResponse<MateTraitAnimation>> {
  return get(`/MateTraitAnimation/${id}`);
}

function updateOneMateTraitAnimation(
  id: number,
  param: Partial<{
    mateTraitId: number;
    name: string;
    type: TraitAnimationType;
    portraitzz: ({ type: TraitAnimationPortraitType } & MatePortrait)[];
  }>
): Promise<WriteResponse<MateTraitAnimation>> {
  return put(`/MateTraitAnimation/${id}`, param);
}

function deleteOneMateTraitAnimation(id: number): Promise<WriteResponse<null>> {
  return deleteOne(`/MateTraitAnimation/${id}`);
}

function payOneChatMessage(id: number): Promise<WriteResponse<ChatMessage>> {
  return put(`/ChatMessage/PayOne/${id}`);
}

function translate(params: {
  text: string;
  targetLanguage: TranslationLanguageEnum;
}): Promise<Response<{ text: string }>> {
  return post(`/Translate`, params);
}

function createUserInvitationCode(): Promise<Response<UserInvitationCode>> {
  return post("/UserInvitationCode");
}

function readUserInvitationCodePage(
  params: PageRequest<{
    isUsed?: boolean;
  }>
): Promise<PageResponse<UserInvitationCode>> {
  return get("/UserInvitationCodePage", params);
}

function checkUserExist(params: {
  email?: string;
  phone?: string;
}): Promise<Response<{ exists: boolean }>> {
  return post("/User/CheckExistence", params);
}

function createOneUserShareReward(params: {
  imageMediaId: number;
}): Promise<WriteResponse<UserShareReward>> {
  return post("/UserShareReward", params);
}

function deleteOneTextImage(uuid: string): Promise<WriteResponse<null>> {
  return deleteOne(`/TextImage/${uuid}`);
}

function updateOneMateHouseSession(
  uuid: string,
  params: {
    mateSpriteIds?: number[];
    subject?: string;
    isAutoUpdateTopic?: boolean;
  }
): Promise<WriteResponse<MateHouseSession>> {
  return put(`/MateHouseSession/${uuid}`, params);
}

function readMateHouseSessionMessagePage(
  params: CursorPageRequest<void> & {
    mateId?: number;
    isGenerateIdeas?: 0 | 1;
  }
): Promise<CursorPageResponse<MateHouseSessionMessage>> {
  return get("/MateHouseSessionMessagePage", params);
}

function deleteMateHouseSessionMessage(
  sessionId: number,
  messageId?: number
): Promise<WriteResponse<null>> {
  let baseUrl = `/MateHouseSessionMessage?sessionId=${sessionId}`;
  if (messageId) {
    baseUrl += `&messageId=${messageId}`;
  }
  return deleteOne(baseUrl);
}

function getOneMateHouseSession(
  uuid: string
): Promise<WriteResponse<MateHouseSession>> {
  return get(`/MateHouseSession/${uuid}`);
}

function cloneOneMate(
  mateId: number,
  isHouseEnabled: boolean
): Promise<WriteResponse<Mate>> {
  return post(`/MateClone`, { mateId, isHouseEnabled });
}

function readPresetMatePage(
  params: PageRequest<{
    isPreset?: 0 | 1;
    type?: MateType;
  }>
): Promise<PageResponse<Mate>> {
  return get("/Mate/ReadPresetPage", params);
}

function createOneMateHouseSessionEvent(params: {
  spriteIds: number[];
  endingId?: number;
  isMessageAudioNeeded?: 0 | 1;
}): Promise<WriteResponse<MateHouseSessionEvent>> {
  return post("/MateHouseSessionEvent", params);
}

function readOneMateHouseSessionEvent(
  id: number
): Promise<WriteResponse<MateHouseSessionEvent>> {
  return get(`/MateHouseSessionEvent/${id}`);
}

function updateOneMateHouseSessionEvent(
  id: number,
  params: Pick<MateHouseSessionEvent, "isPlayed">
): Promise<WriteResponse<MateHouseSessionEvent>> {
  return put(`/MateHouseSessionEvent/${id}`, params);
}

function readHouseEventPage(
  params: PageRequest<{
    location?: HouseEventLocation;
  }>
): Promise<PageResponse<HouseEvent>> {
  return get("/HouseEventPage", params);
}

// HouseMap API functions
async function readHouseMapPage(
  params: PageRequest<{
    rarity?: 1 | 2 | 3 | 4; // EquipmentRarity enum: 1=Common, 2=Rare, 3=Epic, 4=Legendary
    isPreset?: "0" | "1";
    ownership?: "free" | "owned" | "unowned";
  }>
): Promise<PageResponse<HouseMap>> {
  return await get("/HouseMapPage", params);
}

async function createHouseMap(data: {
  name: string;
  description: string;
  mediaId: number;
}): Promise<WriteResponse<HouseMap>> {
  return await post("/HouseMap", data);
}

async function readOneHouseMap(uuid: string): Promise<WriteResponse<HouseMap>> {
  return await get(`/HouseMap/${uuid}`);
}

async function updateHouseMap(
  id: number,
  data: { name: string; description: string; mediaId: number }
): Promise<WriteResponse<HouseMap>> {
  return await put(`/HouseMap/${id}`, data);
}

async function deleteHouseMap(id: number): Promise<Response<void>> {
  return await deleteOne(`/HouseMap/${id}`);
}
1;
// Route::post('/AndroidVersion/CreateOne/{id}', \App\Api\AndroidVersion\CreateOne\CreateOneAndroidVersionController::class)->middleware(['auth']);

function createOneAndroidVersion(
  params: Partial<AndroidVersion>
): Promise<WriteResponse<AndroidVersion>> {
  return post("/AndroidVersion/CreateOne/0", params);
}

async function readMateDispatchMessagePage(
  params: CursorPageRequest<{
    dispatch: string;
  }>
): Promise<CursorPageResponse<MateDispatchMessage>> {
  return get("/MateDispatchMessagePage", params);
}

async function createOneMateDispatchMessage(data: {
  dispatch: string;
  text: string;
  clientMessageId?: string;
}): Promise<
  WriteResponse<{
    queued: boolean;
    gate: {
      status: string;
      until?: string; // ISO 8601
      reason?: string;
      bufferedUserCount?: number;
    };
    messageEcho: { content: string; status: string; uuid: string }[];
  }>
> {
  return post("/MateDispatchMessage", data);
}

function readDispatchTemplatePage(
  params: PageRequest<null>
): Promise<PageResponse<DispatchTemplate>> {
  return get("/DispatchTemplatePage", params);
}

function readOneDispatchTemplate(
  uuid: string
): Promise<WriteResponse<DispatchTemplate>> {
  return get(`/DispatchTemplate/${uuid}`);
}
